// extracted by mini-css-extract-plugin
export default {"thumbnailField":"thumbnailField___xCR4a","inherited":"inherited___JCRYG"};